import React from 'react'
import { SliderKort, SliderTitelCon } from './Slider.styled'

const Card = ({ id, title, text, source, currentIndex }) => {
    return (
        <SliderKort
            key={id}
            className={currentIndex === id ? 'active' : ''}
        >
            <SliderTitelCon key={title}>
                <img
                    src={source}
                    alt={title}
                    height={100}
                    width={100}
                />
                <h2>{title}</h2>
            </SliderTitelCon>
            <p className="description">{text}</p>
        </SliderKort>
    )
}

export default Card